import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { getApiBase } from "../utils/paths";
import './PhotoGallery.css';

const backendBase = getApiBase().replace(/\/backend\/api$/, '/backend');

const resolveImage = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('/backend/uploads/')) return `${backendBase}${path.replace(/^\/backend/, '')}`;
  if (path.startsWith('/uploads/')) return `${backendBase}${path}`;
  if (path.startsWith('/vikash/backend/uploads/')) return path; // legacy
  if (path.startsWith('/vikash/uploads/')) return path; // legacy
  return path.startsWith('/') ? `${backendBase}${path}` : `${backendBase}/${path}`;
};

const Photogallery = () => {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const apiBase = getApiBase();
        const res = await fetch(`${apiBase}/public/gallery.php`);
        if (!res.ok) throw new Error('Unable to load gallery');
        const d = await res.json();
        setItems(Array.isArray(d.items) ? d.items : []);
      } catch (err) {
        console.error('Gallery fetch failed', err);
        setError('Unable to load gallery');
      }
    })();
  }, []);

  return (
    <>
      <Header />

      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/assets/images/backgrounds/Children%27s-Parliament.png)",
          }}
        ></div>
        <div className="shape1 float-bob-x">
          <img
            src="assets/images/shapes/page-header-shape1.png"
            alt=""
            style={{ filter: "hue-rotate(90deg)" }}
          />
        </div>
        <div className="shape2">
          <img
            src="assets/images/shapes/page-header-shape2.png"
            alt=""
            style={{ filter: "hue-rotate(90deg)" }}
          />
        </div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="wow fadeInDown" data-wow-duration="1500ms">
              Our Photo Gallery
            </h2>
          </div>
        </div>
      </section>

      <section className="gallery-page">
        <div className="auto-container clearfix">
          <div className="row">
            {error ? (
              <div className="col-12">
                <p style={{ color: '#dc2626', textAlign: 'center' }}>{error}</p>
              </div>
            ) : items.length === 0 ? (
              <div className="col-12">
                <p style={{ textAlign: 'center' }}>No gallery images available yet.</p>
              </div>
            ) : (
              items.map((item) => (
                <div key={item.id} className="col-xl-3 col-lg-4 col-md-6">
                  <div className="gallery-page__single card">
                    <div className="gallery-page__single-img">
                      <a className="img-popup" href={resolveImage(item.image_path) || '#'}>
                        <img
                          src={resolveImage(item.image_path) || 'assets/images/resources/p1.jpg'}
                          alt={item.title || 'Gallery image'}
                          loading="lazy"
                        />
                      </a>
                    </div>
                    <div className="gallery-page__single-title">
                      <h4 className="gallery-caption">{item.title}</h4>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      <Footer />
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};

export default Photogallery;
